module.exports = __webpack_public_path__ + "static/media/pf.4c112e5a.svg";